module.exports = __webpack_public_path__ + "static/img/48.66194b2c.jpeg";